export enum IRouterDetailsPageTabs {
  Overview = 'overview',
  Interfaces = 'interfaces',
}
